module.exports = __webpack_public_path__ + "img/fuli.f9dc5fdb.png";